import DocReady from 'es6-docready';
import { setCookies, readCookies } from '../../../src/js/utilities/cookies';
var TRANSITION = 400;
var NOTIFICATION_BAR = 'notificationBar';
var IS_ACTIVE = 'is-active';
var IS_TRANSITIONED = 'is-transitioned';
DocReady(function () {
  var notificationBar = document.querySelector("[data-component=\"".concat(NOTIFICATION_BAR, "\"]"));
  if (notificationBar) {
    var notificationBarCloseButton = notificationBar.querySelector('[data-element="notificationBarCloseButton"]');
    var notificationBarHeight = getComputedStyle(notificationBar).height.split('px')[0];
    var notificationBarHash = notificationBar.dataset.hash;
    var siteDomain = notificationBar.dataset.domain;
    var layoutWrapper = document.querySelector('.layout');
    var handleTransitionWithTimeout = function handleTransitionWithTimeout() {
      notificationBar.classList.add(IS_TRANSITIONED);
      setTimeout(function () {
        notificationBar.classList.remove(IS_TRANSITIONED);
      }, TRANSITION);
    };
    var closeNotificationBar = function closeNotificationBar() {
      setCookies(NOTIFICATION_BAR, notificationBarHash, 360, siteDomain);
      handleTransitionWithTimeout();
      notificationBar.classList.remove(IS_ACTIVE);
      layoutWrapper.style.paddingTop = '0';
    };
    var showNotificationBar = function showNotificationBar() {
      handleTransitionWithTimeout();
      notificationBar.classList.add(IS_ACTIVE);
      layoutWrapper.style.paddingTop = "".concat(notificationBarHeight - 2, "px");
    };
    if (readCookies(NOTIFICATION_BAR) !== notificationBarHash) {
      showNotificationBar();
    }
    notificationBarCloseButton.addEventListener('click', closeNotificationBar);
  }
});